var get_all = [
  {
    "date": "2020-02-01",
    "sale": 1775.00
  },
  {
    "date": "2020-03-01",
    "sale": 1780.00
  },
  {
    "date": "2020-04-01",
    "sale": 1785.00
  },
  {
    "date": "2020-05-01",
    "sale": 1790.00
  },
  {
    "date": "2020-06-01",
    "sale": 1795.00
  },
  {
    "date": "2020-07-01",
    "sale": 1800.00
  },
  {
    "date": "2020-08-01",
    "sale":1805.00
  },
  {
    "date": "2020-09-01",
    "sale": 1810.00
  },
  {
    "date": "2020-10-01",
    "sale": 1815.00
  },
  {
    "date": "2020-11-01",
    "sale": 1820.00
  },
  {
    "date": "2020-12-01",
    "sale": 1825.00
  },
  {
    "date": "2021-01-01",
    "sale": 1830.00
  },
  {
    "date": "2021-02-01",
    "sale": 1835.00
  },
  {
    "date": "2021-03-01",
    "sale": 1840.00
  }
]
window.onload = function() {
  var dataPoints = [];
var options1 = {
animationEnabled: true,
	title: {
		text: "Spline Chart using jQuery Plugin"
	},
      subtitles: [{
      text:"Total Retail Sales of ACME "
    }],
      axisX: {
        crosshair: {
          enabled: true,
          snapToDataPoint: true,
          valueFormatString: "MMM YYYY DD"
        }
      },
      axisY: {
        title: "",
        prefix: "",
        suffix: "€",
        crosshair: {
          enabled: true,
          snapToDataPoint: true,
          valueFormatString: "#,###.##€",
        }
      },
      data: [{
        type: "line",
        xValueFormatString: "DD MMM YYYY",
        yValueFormatString: "#,###.##€",
        dataPoints : dataPoints
      }],
      navigator: {
      enabled:false,
    }
};
console.log(options1);
var options2 = {
	title: {
		text: "Spline Area Chart using jQuery Plugin"
	},
	axisX: {
		labelFontSize: 14
	},
	axisY: {
		labelFontSize: 14
	},
	data: [{
		type: "splineArea", //change it to line, area, bar, pie, etc
		dataPoints: [
			{ y: 10 },
			{ y: 6 },
			{ y: 14 },
			{ y: 12 },
			{ y: 19 },
			{ y: 14 },
			{ y: 26 },
			{ y: 10 },
			{ y: 22 }
		]
	}]
};
  console.log(options2);
    for(var i = 0; i < 10; i++){
      dataPoints.push({x: new Date(get_all[i].date), y: Number(get_all[i].sale)});
    }

$("#tabs").tabs({
	create: function (event, ui) {
		//Render Charts after tabs have been created.
		$("#chartContainer1").CanvasJSChart(options1);
		$("#chartContainer2").CanvasJSChart(options2);
	},
	activate: function (event, ui) {
		//Updates the chart to its container size if it has changed.
		ui.newPanel.children().first().CanvasJSChart().render();
	}
});

}


